import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  content: {
    display: 'inline-block',
    border: `2px solid ${theme.palette.primary.main}`,
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 1.5}px`,
    borderRadius: 8,
  }
})

const Warning = ({ children, classes }) => (
  <div>
    <Typography className={classes.content}>
      { children }
    </Typography>
  </div>
)

Warning.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.any,
}

export default withStyles(styles)(Warning)
